// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__1ryiw","focused":"SearchInput_focused__3-Zc-","icon":"SearchInput_icon__3AkE2","inputArea":"SearchInput_inputArea__3ErN_"};